module.exports = __webpack_public_path__ + "img/bannerMember.d5252090.png";